import { key as busyKey } from "./busy/action";
import busyReducer from "./busy/reducer";
import { combineReducers } from "redux-immutable";
import { key as commonKey } from "./common/action";
import commonReducer from "./common/reducer";
import { key as errorKey } from "./error/action";
import errorReducer from "./error/reducer";
import { key as pollKey } from "./poll/action";
import pollReducer from "./poll/reducer";
import { key as userKey } from "./user/action";
import userReducer from "./user/reducer";
import { key as usersKey } from "./users/action";
import usersReducer from "./users/reducer";
import { key as servicesKey } from "./services/action";
import servicesReducer from "./services/reducer";
import { key as modelsKey } from "./models/action";
import modelsReducer from "./models/reducer";
import { key as commentsKey } from "./comments/action";
import commentsReducer from "./comments/reducer";
import { key as samplesKey } from "./samples/action";
import samplesReducer from "./samples/reducer";

export default combineReducers({
  [userKey]: userReducer,
  [usersKey]: usersReducer,
  [busyKey]: busyReducer,
  [errorKey]: errorReducer,
  [pollKey]: pollReducer,
  [commonKey]: commonReducer,
  [servicesKey]: servicesReducer,
  [modelsKey]: modelsReducer,
  [commentsKey]: commentsReducer,
  [samplesKey]: samplesReducer,
});
